"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerLabelListItem = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ManagerLabelListItem = styled_components_1.default.li `
  padding: 5px;
  font-size: 11px;
  cursor: pointer;
`;
//# sourceMappingURL=label-list-item.js.map